// extracted by mini-css-extract-plugin
module.exports = {"charts":"Index_charts__qKkox","fillup":"Index_fillup__5_iXC","fade":"Index_fade__Z9Ns9","fillhorizon":"Index_fillhorizon__kUWIC","lastSection":"Index_lastSection__d9Ply"};